import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import '../../Layout/Box/Box.js';
import { Inline } from '../../Layout/Inline/Inline.js';
import '../../Layout/Stack/Stack.js';
import { TreatwellSpinner } from '../../Internal/TreatwellSpinner/TreatwellSpinner.js';
import { useDelayMount } from './useDelayMount.js';

function Loading({ delay = 200 }) {
    const mounted = useDelayMount(delay);
    const component = (jsxRuntimeExports.jsx(Inline, { justify: "center", align: "center", children: jsxRuntimeExports.jsx(TreatwellSpinner, {}) }));
    if (delay === 0) {
        return component;
    }
    return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: mounted && component });
}

export { Loading };
//# sourceMappingURL=Loading.js.map
